import { getItem } from '@/utils/local-storage'
import { isAuthenticated } from '@/utils/auth'
import { AUTH_TYPES } from '@/store/modules/auth'
import store from '@/store'

export const session = async (fetchUser = false) => {
  const ignoreCheck = getItem('ignore_auth_check')
  if (isAuthenticated() && !ignoreCheck) {
    await store.dispatch(AUTH_TYPES.actions.trySetAccessToken, fetchUser)
  }
}

export default session()
